import React, { useState, useEffect } from "react";
import twitterIcon from "../../../../public/icons/twitterX_light.svg";
import { requestAuthUrl, connectTwitterAccount, disconnectTwitterAccount } from "../../../../api/twitter";
import { updateCurrentUserRedux } from "../../../../api/helper";
import { Spinner } from "react-bootstrap";
import { useLocation, useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";

export default ({ user }) => {
  let location = useLocation();
  let history = useHistory();
  let [loading, setLoading] = useState(false);
  let [link, setLink] = useState(null);
  let searchParams = new URLSearchParams(location.search);
  const fetchLink = async () => {
    if (searchParams.has("oauth_token") && searchParams.has("oauth_verifier")) {
      try {
        setLoading(true);
        let oauth_token = searchParams.get("oauth_token");
        let oauth_verifier = searchParams.get("oauth_verifier");
        await connectTwitterAccount({
          oauth_token,
          oauth_verifier,
        }); // fetch revoke link
        /*
        if (isMobile) {
          window.location.href = "hudl://";
        } else {
          history.replace("/");
        }
          */
        updateCurrentUserRedux();
        setLink("revoke url");
      } catch (error) {
        console.log(error);
        history.push("/settings");
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } else if (!user.is_twitter_connected) {
      try {
        let {
          data: { url },
        } = await requestAuthUrl();
        setLink(url);
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const disconnect = async () => {
    try {
      setLoading(true);
      await disconnectTwitterAccount();
      updateCurrentUserRedux();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLink();
    return () => {};
  }, [user.is_twitter_connected]);

  return (
    <div className="form-row">
      <div className="col-25 d-flex align-items-center">
        <label className="m-0" style={{ whiteSpace: "nowrap" }}>
          X Account
        </label>
      </div>
      <div className="col-75">
        {loading ? (
          <button className="twitter-auth-btn">
            <img src={twitterIcon} alt="twitter-logo" className="mr-2" />
            <Spinner animation="border" variant="white" size="sm">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </button>
        ) : !user.is_twitter_connected ? (
          <a className="twitter-auth-btn" href={link}>
            Connect to
            <img src={twitterIcon} alt="twitter-logo" />
          </a>
        ) : (
          <button className="twitter-auth-btn" onClick={disconnect}>
            Disconnect from
            <img src={twitterIcon} alt="twitter-logo" />
          </button>
        )}
      </div>
    </div>
  );
};
